var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create-booking-page"},[_c('BackTitle',{attrs:{"confirm-click":""},on:{"click":_vm.goBack}},[_vm._v(" "+_vm._s(_vm.$t("Create booking"))+" ")]),_c('BookingForm',{attrs:{"value":_vm.booking,"isSubmitting":_vm.isLoading,"isShowOverbookOption":_vm.isShowOverbookOption},on:{"submit":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }